// Types
import { Breakpoints } from '@globalTypes/index';
import { SectionConfig } from '@/src/components/molecules';

/**
 * Filters sections based on the specified customer.
 *
 * @param {string} sub - The user sub for which sections are being filtered.
 * @returns {SectionConfig[]} - An object containing arrays of enabled and disabled sections.
 */
export const sectionFilter = (sections: SectionConfig[], breakpoint: Breakpoints): SectionConfig[] =>
  sections
    .map((section) => {
      const { links } = section;

      return {
        ...section,
        links: links.filter((link) => {
          const userAllowed = link.isAuthorized;
          const breakpointAllowed = link.breakPointBlackList ? !link.breakPointBlackList.includes(breakpoint) : true;

          return userAllowed && breakpointAllowed;
        }),
      };
    })
    .filter((section) => section.links.length > 0);
